export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9884.13f950c6.jpg";